import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { of } from "rxjs";
import { catchError, map, mergeMap, tap } from "rxjs/operators";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
    clientAccountsError,
    getMyClientAccounts,
    myClientAccountsLoaded,
    setSelectedClientAccountId,
} from "../actions/client-account.actions";
import { StorageUtilsService } from "app/services/storage-utils/storage-utils.service";
import { AuthService } from "@core/auth/auth.service";

@Injectable()
export class ClientAccountsEffect {
    actions$ = inject(Actions);
    _router = inject(Router);
    private _userService = inject(AuthService);
    private _storageUtilsService = inject(StorageUtilsService);

    getMyClientAccounts$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(getMyClientAccounts),
            mergeMap(() => {
                return this._userService.getAccountsClients().pipe(
                    map((myClientAccounts) =>
                        myClientAccountsLoaded({ myClientAccounts }),
                    ),
                    catchError((error) => of(clientAccountsError({ error }))),
                );
            }),
        );
    });

    setSelectedClientAccountIdEff$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(setSelectedClientAccountId),
            tap(({ selectedClientAccountId }) => {
                /** set selected folder value in storage */
                this._storageUtilsService.setSelectedAccountId(selectedClientAccountId);
            }),
        );
    }, { dispatch: false });
}
